// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActionButtonType } from "./action-button-type";
import { ActionFloorScope } from "./action-floor-scope";
import { ActionScope } from "./action-scope";
import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

export class ActionBank implements flatbuffers.IUnpackableObject<ActionBankT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ActionBank {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsActionBank(bb: flatbuffers.ByteBuffer, obj?: ActionBank): ActionBank {
    return (obj || new ActionBank()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsActionBank(bb: flatbuffers.ByteBuffer, obj?: ActionBank): ActionBank {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ActionBank()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  messageId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  actionId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  toggleActionId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  toggleMessageId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  buttonType(): ActionButtonType {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionButtonType.TOGGLE;
  }

  label(): string | null;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  label(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  toggleLabel(): string | null;
  toggleLabel(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  toggleLabel(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * `PostgreSQL` text[] — valid monitoring states for button visibility.
   */
  validStates(index: number): string;
  validStates(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  validStates(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  validStatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  toggleValidStates(index: number): string;
  toggleValidStates(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  toggleValidStates(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  toggleValidStatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  color(): string | null;
  color(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  color(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  color2(): string | null;
  color2(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  color2(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  toggleColor(): string | null;
  toggleColor(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  toggleColor(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  timer(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  timer2(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  toggleTimer(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The lift this button is scoped to, projected from the joined
   * `ActionCatalog.lift_id`. NULL = bank-wide, applying to every lift in
   * the bank — the value `SeedBankControlActions` writes — so a consumer
   * must read absent as "all lifts", never as "no lifts".
   *
   * `ActionBank` is keyed on (message_id, bank_id) and carries no lift of
   * its own, so before this field the monitoring control panel had no way
   * to tell a per-car action from a bank-wide one and rendered every
   * action on every car. The catalog is not reachable from here —
   * `action_id` is only an id, and no nested table is emitted — so the
   * scope has to travel on the row itself. Appended last, so buffers
   * written before it stay readable.
   */
  liftId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Whether this button's bound command takes a floor position, projected
   * from the joined `Message.position`.
   *
   * Monitoring draws a positional command as a strip of floor buttons and a
   * positionless one as a plain button; drawn the wrong way, a positional
   * command dispatches floor 0, which is a different command from the one
   * the operator picked. The JSON path answers this from the preloaded
   * `message` relation, but no nested table is emitted here — the same
   * reason `lift_id` had to be added above — so the flag has to travel on
   * the row itself.
   *
   * `false` is indistinguishable from absent, and MUST be read as "no answer
   * from the server" rather than "takes no floor": `messages.position` is a
   * NOT NULL column with no default, so a message row that was never
   * populated already reads false. A consumer falls back to its own command
   * classifier there. Appended last, so buffers written before it stay
   * readable.
   */
  position(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Where this button belongs, from the bound command's key encoding.
   *
   * Projected in `LiftCloud` from `keys.units_based` / `keys.bank_level` for
   * the key that carries this action's message on the bank's adapter. A
   * unit-based command addresses a single car and belongs on that car's
   * Actions tab; a bank-level command addresses the group and belongs on the
   * bank drawer's. Before this field the panels split on `lift_id`, which
   * answers a different question (which car the WIZARD scoped it to, not how
   * the vendor ENCODES it), so a unit-based command with no wizard scope
   * rendered on the bank drawer.
   *
   * Defaults to UNKNOWN so a server that predates the field is explicitly
   * silent rather than implicitly claiming BANK. Appended last, so buffers
   * written before it stay readable.
   */
  actionScope(): ActionScope {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionScope.UNKNOWN;
  }

  /**
   * Expected-response verification: the ids of the `messages` rows whose
   * arrival confirms this button's command succeeded.
   *
   * Same storage convention as `valid_states` — a `PostgreSQL` text[] of
   * message UUIDs, carried as a `FlatBuffer` string vector. Every listed
   * message must be observed (active) at least once within
   * `expected_response_timeout` for the press to count as verified. This is
   * the runtime copy the monitoring control panel reads when the operator
   * presses the button; the catalog's `expected_response` is the
   * wizard-level default.
   *
   * INVARIANT: absent/empty means the action has NO expected response. A
   * consumer must report such a press as "sent, unverifiable" — never as
   * verified and never as failed.
   *
   * SLOT ORDER IS LOAD-BEARING. This field MUST stay after `action_scope`.
   * An earlier draft of this change was authored in parallel with
   * `action_scope` and both landed on field slot 21 — `action_scope` as a
   * byte, this as a table offset. That compiles, passes every test in this
   * repo, and corrupts decoding only ACROSS versions, where a reader pinned
   * to one schema reads the other's vector offset as an enum byte.
   * `action_scope` shipped first on a release line and is therefore
   * immutable; this field takes the next slot. Never reorder these.
   */
  expectedResponse(index: number): string;
  expectedResponse(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  expectedResponse(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  expectedResponseLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Verification window in seconds for `expected_response`.
   *
   * INVARIANT: 0 is indistinguishable from absent and means UNSET — the
   * consumer applies its own default window. It is NOT "no timeout" and NOT
   * "verify immediately". Only meaningful when `expected_response` is
   * non-empty. Appended last, so buffers written before it stay readable.
   */
  expectedResponseTimeout(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Whether this button's command takes a floor, from the bound command's
   * key encoding (`keys.floors_based`). UNKNOWN means the server could not
   * tell and the consumer must fall back to its own classifier — never
   * demote on UNKNOWN. See [ActionFloorScope]. Appended last, so buffers
   * written before it stay readable.
   */
  floorScope(): ActionFloorScope {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionFloorScope.UNKNOWN;
  }

  /**
   * The bound command's enum value, carried on the ROW.
   *
   * WHY THIS HAS TO BE HERE. The command an action sends lives on the
   * `action_catalogs` relation, not on this table, and no nested table is
   * emitted for it — the same reason `lift_id`, `position`, `action_scope`
   * and `floor_scope` each had to be projected onto the row individually.
   * While this endpoint answered in JSON the relation travelled anyway,
   * preloaded by GORM, and consumers read it. The moment the endpoint began
   * packing, the relation was dropped at pack time and every consumer lost
   * the binding at once: the button that says which command it sends could
   * no longer find one, and the editor's Command columns went blank.
   *
   * WHY -1 AND NOT 0. `Control` numbers its first member `CarCallLock = 0`,
   * so 0 is a LEGITIMATE command and cannot double as "unset". A scalar
   * written at its default is indistinguishable from an absent one, so the
   * default has to be a value no command can take. -1 is outside the enum
   * in both directions of the wire and is the only safe choice.
   *
   * INVARIANT: -1 means the row carries no binding, and a consumer must
   * refuse to send rather than guess. It must NOT fall back to 0 — that
   * would silently send CarCallLock for every unbound button on the panel.
   *
   * Appended last, so buffers written before it stay readable.
   */
  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
  }

  /**
   * The toggle half's command enum value. Same contract as `message_value`,
   * including the -1 sentinel: a TOGGLE button binds two commands and either
   * half can be unbound independently. Appended last.
   */
  toggleMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
  }

  /**
   * Which CATEGORY `message_value` belongs to, as `MessageContent`.
   *
   * AN ENUM VALUE IS MEANINGLESS WITHOUT ITS CATEGORY. The LN2 message
   * categories are separate enums that each start at 0, so their values
   * collide numerically: 29 is `Traffic::CarToLobby` AND
   * `Control::DisableDoor`; 27 is `Traffic::IndependentService` AND
   * `Control::RunDown`. A consumer holding only the number cannot tell them
   * apart, and — this is the dangerous part — a lookup against the wrong
   * category SUCCEEDS and yields a real, different command. It does not
   * fail loudly; it silently names something else.
   *
   * That is not hypothetical. A monitoring client resolved every action's
   * value against `Control` because the category was not on the wire to
   * consult, and two buttons bound to Traffic messages came out addressing
   * `Control::RunDown` and `Control::DisableDoor`.
   *
   * INVARIANT: a consumer must treat an action as sendable ONLY when this
   * reads `Control_ControlMessage`. Any other category means the button is
   * bound to something the controller REPORTS rather than accepts, and it
   * must not be dispatched.
   *
   * Typed `short` and 0-defaulted to match `Message.message_content_type`,
   * which is the table this value is copied from; a second numbering for one
   * concept is what drifts. The values are `Ln2.MessageContent`, whose NONE
   * is 0.
   *
   * 0 (NONE) is the "server did not say" value and must be read as UNKNOWN,
   * not as a category. A consumer seeing 0 falls back to its own
   * classification rather than assuming Control — assuming is the bug this
   * field exists to end.
   *
   * Appended last, so buffers written before it stay readable.
   */
  messageContentType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * The toggle half's category. Same contract as `message_content_type`.
   * Appended last.
   */
  toggleMessageContentType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * The unit class and target car the bound command addresses, projected
   * from the joined `ActionCatalog`.
   *
   * `ActionBank` carries an `action_id`, but no nested catalog table is
   * emitted, so an id is all a `FlatBuffer` consumer gets — it cannot follow
   * it. Anything the catalog knows and a consumer needs therefore has to
   * travel on the row. That is already why `lift_id`, `position`,
   * `message_value` and `action_scope` are here; these two complete the set.
   *
   * The command's NAME is deliberately NOT among them. The row already
   * carries `message_value` with `message_content_type`, and the pair names
   * the command exactly via the generated `Control` enum. Shipping the name
   * as a string beside the value would put two sources of truth on the wire
   * with no rule for which wins when they disagree — and the enum is the one
   * that breaks at compile time when the schema moves.
   *
   * The unit class, from `ActionCatalog.lift_type`. Appended last.
   */
  liftType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  /**
   * The car this catalog entry targets, from `ActionCatalog.target_position`
   * — the lift's `position`, not its array index.
   *
   * -1 means bank-scoped (SQL NULL), which is what `SeedBankControlActions`
   * writes for a bank-wide command. 0 is a real car, so absence cannot be
   * encoded as 0. Appended last.
   */
  targetPosition(): number {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
  }

  static startActionBank(builder: flatbuffers.Builder) {
    builder.startObject(31);
  }

  static addMessageId(builder: flatbuffers.Builder, messageIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, messageIdOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addActionId(builder: flatbuffers.Builder, actionIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, actionIdOffset, 0);
  }

  static addToggleActionId(builder: flatbuffers.Builder, toggleActionIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, toggleActionIdOffset, 0);
  }

  static addToggleMessageId(
    builder: flatbuffers.Builder,
    toggleMessageIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, toggleMessageIdOffset, 0);
  }

  static addButtonType(builder: flatbuffers.Builder, buttonType: ActionButtonType) {
    builder.addFieldInt8(6, buttonType, ActionButtonType.TOGGLE);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, labelOffset, 0);
  }

  static addToggleLabel(builder: flatbuffers.Builder, toggleLabelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, toggleLabelOffset, 0);
  }

  static addValidStates(builder: flatbuffers.Builder, validStatesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, validStatesOffset, 0);
  }

  static createValidStatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startValidStatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addToggleValidStates(
    builder: flatbuffers.Builder,
    toggleValidStatesOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, toggleValidStatesOffset, 0);
  }

  static createToggleValidStatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startToggleValidStatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, colorOffset, 0);
  }

  static addColor2(builder: flatbuffers.Builder, color2Offset: flatbuffers.Offset) {
    builder.addFieldOffset(12, color2Offset, 0);
  }

  static addToggleColor(builder: flatbuffers.Builder, toggleColorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, toggleColorOffset, 0);
  }

  static addTimer(builder: flatbuffers.Builder, timer: number) {
    builder.addFieldInt32(14, timer, 0);
  }

  static addTimer2(builder: flatbuffers.Builder, timer2: number) {
    builder.addFieldInt32(15, timer2, 0);
  }

  static addToggleTimer(builder: flatbuffers.Builder, toggleTimer: number) {
    builder.addFieldInt32(16, toggleTimer, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, updatedAtOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, liftIdOffset, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: boolean) {
    builder.addFieldInt8(20, +position, +false);
  }

  static addActionScope(builder: flatbuffers.Builder, actionScope: ActionScope) {
    builder.addFieldInt8(21, actionScope, ActionScope.UNKNOWN);
  }

  static addExpectedResponse(
    builder: flatbuffers.Builder,
    expectedResponseOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(22, expectedResponseOffset, 0);
  }

  static createExpectedResponseVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startExpectedResponseVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addExpectedResponseTimeout(builder: flatbuffers.Builder, expectedResponseTimeout: number) {
    builder.addFieldInt32(23, expectedResponseTimeout, 0);
  }

  static addFloorScope(builder: flatbuffers.Builder, floorScope: ActionFloorScope) {
    builder.addFieldInt8(24, floorScope, ActionFloorScope.UNKNOWN);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(25, messageValue, -1);
  }

  static addToggleMessageValue(builder: flatbuffers.Builder, toggleMessageValue: number) {
    builder.addFieldInt32(26, toggleMessageValue, -1);
  }

  static addMessageContentType(builder: flatbuffers.Builder, messageContentType: number) {
    builder.addFieldInt16(27, messageContentType, 0);
  }

  static addToggleMessageContentType(
    builder: flatbuffers.Builder,
    toggleMessageContentType: number,
  ) {
    builder.addFieldInt16(28, toggleMessageContentType, 0);
  }

  static addLiftType(builder: flatbuffers.Builder, liftType: LiftType) {
    builder.addFieldInt8(29, liftType, LiftType.ELEVATOR);
  }

  static addTargetPosition(builder: flatbuffers.Builder, targetPosition: number) {
    builder.addFieldInt32(30, targetPosition, -1);
  }

  static endActionBank(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // message_id
    builder.requiredField(offset, 6); // bank_id
    builder.requiredField(offset, 8); // organization_id
    return offset;
  }

  unpack(): ActionBankT {
    return new ActionBankT(
      this.messageId() !== null ? this.messageId()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.actionId() !== null ? this.actionId()!.unpack() : null,
      this.toggleActionId() !== null ? this.toggleActionId()!.unpack() : null,
      this.toggleMessageId() !== null ? this.toggleMessageId()!.unpack() : null,
      this.buttonType(),
      this.label(),
      this.toggleLabel(),
      this.bb!.createScalarList<string>(this.validStates.bind(this), this.validStatesLength()),
      this.bb!.createScalarList<string>(
        this.toggleValidStates.bind(this),
        this.toggleValidStatesLength(),
      ),
      this.color(),
      this.color2(),
      this.toggleColor(),
      this.timer(),
      this.timer2(),
      this.toggleTimer(),
      this.createdAt(),
      this.updatedAt(),
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.position(),
      this.actionScope(),
      this.bb!.createScalarList<string>(
        this.expectedResponse.bind(this),
        this.expectedResponseLength(),
      ),
      this.expectedResponseTimeout(),
      this.floorScope(),
      this.messageValue(),
      this.toggleMessageValue(),
      this.messageContentType(),
      this.toggleMessageContentType(),
      this.liftType(),
      this.targetPosition(),
    );
  }

  unpackTo(_o: ActionBankT): void {
    _o.messageId = this.messageId() !== null ? this.messageId()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.actionId = this.actionId() !== null ? this.actionId()!.unpack() : null;
    _o.toggleActionId = this.toggleActionId() !== null ? this.toggleActionId()!.unpack() : null;
    _o.toggleMessageId = this.toggleMessageId() !== null ? this.toggleMessageId()!.unpack() : null;
    _o.buttonType = this.buttonType();
    _o.label = this.label();
    _o.toggleLabel = this.toggleLabel();
    _o.validStates = this.bb!.createScalarList<string>(
      this.validStates.bind(this),
      this.validStatesLength(),
    );
    _o.toggleValidStates = this.bb!.createScalarList<string>(
      this.toggleValidStates.bind(this),
      this.toggleValidStatesLength(),
    );
    _o.color = this.color();
    _o.color2 = this.color2();
    _o.toggleColor = this.toggleColor();
    _o.timer = this.timer();
    _o.timer2 = this.timer2();
    _o.toggleTimer = this.toggleTimer();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.position = this.position();
    _o.actionScope = this.actionScope();
    _o.expectedResponse = this.bb!.createScalarList<string>(
      this.expectedResponse.bind(this),
      this.expectedResponseLength(),
    );
    _o.expectedResponseTimeout = this.expectedResponseTimeout();
    _o.floorScope = this.floorScope();
    _o.messageValue = this.messageValue();
    _o.toggleMessageValue = this.toggleMessageValue();
    _o.messageContentType = this.messageContentType();
    _o.toggleMessageContentType = this.toggleMessageContentType();
    _o.liftType = this.liftType();
    _o.targetPosition = this.targetPosition();
  }

  unpackFields(...fields: string[]): ActionBankT {
    const t = new ActionBankT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_id")) {
      t.messageId = this.messageId() !== null ? this.messageId()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("action_id")) {
      t.actionId = this.actionId() !== null ? this.actionId()!.unpack() : null;
    }
    if (fieldSet.has("toggle_action_id")) {
      t.toggleActionId = this.toggleActionId() !== null ? this.toggleActionId()!.unpack() : null;
    }
    if (fieldSet.has("toggle_message_id")) {
      t.toggleMessageId = this.toggleMessageId() !== null ? this.toggleMessageId()!.unpack() : null;
    }
    if (fieldSet.has("button_type")) {
      t.buttonType = this.buttonType();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    if (fieldSet.has("toggle_label")) {
      t.toggleLabel = this.toggleLabel();
    }
    if (fieldSet.has("valid_states")) {
      t.validStates = this.bb!.createScalarList<string>(
        this.validStates.bind(this),
        this.validStatesLength(),
      );
    }
    if (fieldSet.has("toggle_valid_states")) {
      t.toggleValidStates = this.bb!.createScalarList<string>(
        this.toggleValidStates.bind(this),
        this.toggleValidStatesLength(),
      );
    }
    if (fieldSet.has("color")) {
      t.color = this.color();
    }
    if (fieldSet.has("color2")) {
      t.color2 = this.color2();
    }
    if (fieldSet.has("toggle_color")) {
      t.toggleColor = this.toggleColor();
    }
    if (fieldSet.has("timer")) {
      t.timer = this.timer();
    }
    if (fieldSet.has("timer2")) {
      t.timer2 = this.timer2();
    }
    if (fieldSet.has("toggle_timer")) {
      t.toggleTimer = this.toggleTimer();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("action_scope")) {
      t.actionScope = this.actionScope();
    }
    if (fieldSet.has("expected_response")) {
      t.expectedResponse = this.bb!.createScalarList<string>(
        this.expectedResponse.bind(this),
        this.expectedResponseLength(),
      );
    }
    if (fieldSet.has("expected_response_timeout")) {
      t.expectedResponseTimeout = this.expectedResponseTimeout();
    }
    if (fieldSet.has("floor_scope")) {
      t.floorScope = this.floorScope();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("toggle_message_value")) {
      t.toggleMessageValue = this.toggleMessageValue();
    }
    if (fieldSet.has("message_content_type")) {
      t.messageContentType = this.messageContentType();
    }
    if (fieldSet.has("toggle_message_content_type")) {
      t.toggleMessageContentType = this.toggleMessageContentType();
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("target_position")) {
      t.targetPosition = this.targetPosition();
    }
    return t;
  }
}

export class ActionBankT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageId: UuidT | null = null,
    public bankId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public actionId: UuidT | null = null,
    public toggleActionId: UuidT | null = null,
    public toggleMessageId: UuidT | null = null,
    public buttonType: ActionButtonType = ActionButtonType.TOGGLE,
    public label: string | Uint8Array | null = null,
    public toggleLabel: string | Uint8Array | null = null,
    public validStates: string[] = [],
    public toggleValidStates: string[] = [],
    public color: string | Uint8Array | null = null,
    public color2: string | Uint8Array | null = null,
    public toggleColor: string | Uint8Array | null = null,
    public timer: number = 0,
    public timer2: number = 0,
    public toggleTimer: number = 0,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public liftId: UuidT | null = null,
    public position: boolean = false,
    public actionScope: ActionScope = ActionScope.UNKNOWN,
    public expectedResponse: string[] = [],
    public expectedResponseTimeout: number = 0,
    public floorScope: ActionFloorScope = ActionFloorScope.UNKNOWN,
    public messageValue: number = -1,
    public toggleMessageValue: number = -1,
    public messageContentType: number = 0,
    public toggleMessageContentType: number = 0,
    public liftType: LiftType = LiftType.ELEVATOR,
    public targetPosition: number = -1,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.messageId === null || this.messageId === undefined) {
      throw new Error('Required field "message_id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    const messageId = this.messageId !== null ? this.messageId!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const actionId = this.actionId !== null ? this.actionId!.pack(builder) : 0;
    const toggleActionId = this.toggleActionId !== null ? this.toggleActionId!.pack(builder) : 0;
    const toggleMessageId = this.toggleMessageId !== null ? this.toggleMessageId!.pack(builder) : 0;
    const label = this.label !== null ? builder.createString(this.label!) : 0;
    const toggleLabel = this.toggleLabel !== null ? builder.createString(this.toggleLabel!) : 0;
    const validStates = ActionBank.createValidStatesVector(
      builder,
      builder.createObjectOffsetList(this.validStates),
    );
    const toggleValidStates = ActionBank.createToggleValidStatesVector(
      builder,
      builder.createObjectOffsetList(this.toggleValidStates),
    );
    const color = this.color !== null ? builder.createString(this.color!) : 0;
    const color2 = this.color2 !== null ? builder.createString(this.color2!) : 0;
    const toggleColor = this.toggleColor !== null ? builder.createString(this.toggleColor!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const expectedResponse = ActionBank.createExpectedResponseVector(
      builder,
      builder.createObjectOffsetList(this.expectedResponse),
    );

    ActionBank.startActionBank(builder);
    ActionBank.addMessageId(builder, messageId);
    ActionBank.addBankId(builder, bankId);
    ActionBank.addOrganizationId(builder, organizationId);
    ActionBank.addActionId(builder, actionId);
    ActionBank.addToggleActionId(builder, toggleActionId);
    ActionBank.addToggleMessageId(builder, toggleMessageId);
    ActionBank.addButtonType(builder, this.buttonType);
    ActionBank.addLabel(builder, label);
    ActionBank.addToggleLabel(builder, toggleLabel);
    ActionBank.addValidStates(builder, validStates);
    ActionBank.addToggleValidStates(builder, toggleValidStates);
    ActionBank.addColor(builder, color);
    ActionBank.addColor2(builder, color2);
    ActionBank.addToggleColor(builder, toggleColor);
    ActionBank.addTimer(builder, this.timer);
    ActionBank.addTimer2(builder, this.timer2);
    ActionBank.addToggleTimer(builder, this.toggleTimer);
    ActionBank.addCreatedAt(builder, createdAt);
    ActionBank.addUpdatedAt(builder, updatedAt);
    ActionBank.addLiftId(builder, liftId);
    ActionBank.addPosition(builder, this.position);
    ActionBank.addActionScope(builder, this.actionScope);
    ActionBank.addExpectedResponse(builder, expectedResponse);
    ActionBank.addExpectedResponseTimeout(builder, this.expectedResponseTimeout);
    ActionBank.addFloorScope(builder, this.floorScope);
    ActionBank.addMessageValue(builder, this.messageValue);
    ActionBank.addToggleMessageValue(builder, this.toggleMessageValue);
    ActionBank.addMessageContentType(builder, this.messageContentType);
    ActionBank.addToggleMessageContentType(builder, this.toggleMessageContentType);
    ActionBank.addLiftType(builder, this.liftType);
    ActionBank.addTargetPosition(builder, this.targetPosition);

    return ActionBank.endActionBank(builder);
  }

  clone(): ActionBankT {
    const obj = new ActionBankT();
    obj.messageId = this.messageId !== null ? this.messageId!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.actionId = this.actionId !== null ? this.actionId!.clone() : null;
    obj.toggleActionId = this.toggleActionId !== null ? this.toggleActionId!.clone() : null;
    obj.toggleMessageId = this.toggleMessageId !== null ? this.toggleMessageId!.clone() : null;
    obj.buttonType = this.buttonType;
    obj.label = this.label;
    obj.toggleLabel = this.toggleLabel;
    obj.validStates = [...this.validStates];
    obj.toggleValidStates = [...this.toggleValidStates];
    obj.color = this.color;
    obj.color2 = this.color2;
    obj.toggleColor = this.toggleColor;
    obj.timer = this.timer;
    obj.timer2 = this.timer2;
    obj.toggleTimer = this.toggleTimer;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.position = this.position;
    obj.actionScope = this.actionScope;
    obj.expectedResponse = [...this.expectedResponse];
    obj.expectedResponseTimeout = this.expectedResponseTimeout;
    obj.floorScope = this.floorScope;
    obj.messageValue = this.messageValue;
    obj.toggleMessageValue = this.toggleMessageValue;
    obj.messageContentType = this.messageContentType;
    obj.toggleMessageContentType = this.toggleMessageContentType;
    obj.liftType = this.liftType;
    obj.targetPosition = this.targetPosition;
    return obj;
  }

  equals(other: ActionBankT): boolean {
    if (this.messageId !== null && other.messageId !== null) {
      if (!this.messageId!.equals(other.messageId!)) return false;
    } else if (this.messageId !== other.messageId) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.actionId !== null && other.actionId !== null) {
      if (!this.actionId!.equals(other.actionId!)) return false;
    } else if (this.actionId !== other.actionId) return false;
    if (this.toggleActionId !== null && other.toggleActionId !== null) {
      if (!this.toggleActionId!.equals(other.toggleActionId!)) return false;
    } else if (this.toggleActionId !== other.toggleActionId) return false;
    if (this.toggleMessageId !== null && other.toggleMessageId !== null) {
      if (!this.toggleMessageId!.equals(other.toggleMessageId!)) return false;
    } else if (this.toggleMessageId !== other.toggleMessageId) return false;
    if (this.buttonType !== other.buttonType) return false;
    if (this.label !== other.label) return false;
    if (this.toggleLabel !== other.toggleLabel) return false;
    if (this.validStates.length !== other.validStates.length) return false;
    for (let i = 0; i < this.validStates.length; i++) {
      if (this.validStates[i] !== other.validStates[i]) return false;
    }
    if (this.toggleValidStates.length !== other.toggleValidStates.length) return false;
    for (let i = 0; i < this.toggleValidStates.length; i++) {
      if (this.toggleValidStates[i] !== other.toggleValidStates[i]) return false;
    }
    if (this.color !== other.color) return false;
    if (this.color2 !== other.color2) return false;
    if (this.toggleColor !== other.toggleColor) return false;
    if (this.timer !== other.timer) return false;
    if (this.timer2 !== other.timer2) return false;
    if (this.toggleTimer !== other.toggleTimer) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.position !== other.position) return false;
    if (this.actionScope !== other.actionScope) return false;
    if (this.expectedResponse.length !== other.expectedResponse.length) return false;
    for (let i = 0; i < this.expectedResponse.length; i++) {
      if (this.expectedResponse[i] !== other.expectedResponse[i]) return false;
    }
    if (this.expectedResponseTimeout !== other.expectedResponseTimeout) return false;
    if (this.floorScope !== other.floorScope) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.toggleMessageValue !== other.toggleMessageValue) return false;
    if (this.messageContentType !== other.messageContentType) return false;
    if (this.toggleMessageContentType !== other.toggleMessageContentType) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.targetPosition !== other.targetPosition) return false;
    return true;
  }
}

export function verifyActionBank(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "message_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 14);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 32, 4);
    verifier.checkScalarField(tablePos, 34, 4);
    verifier.checkScalarField(tablePos, 36, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 42);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 44, 1);
    verifier.checkScalarField(tablePos, 46, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkScalarField(tablePos, 50, 4);
    verifier.checkScalarField(tablePos, 52, 1);
    verifier.checkScalarField(tablePos, 54, 4);
    verifier.checkScalarField(tablePos, 56, 4);
    verifier.checkScalarField(tablePos, 58, 2);
    verifier.checkScalarField(tablePos, 60, 2);
    verifier.checkScalarField(tablePos, 62, 1);
    verifier.checkScalarField(tablePos, 64, 4);
  } finally {
    verifier.popDepth();
  }
}
